import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';

export function withoutRelations(object) {
    object = cloneDeep(object || {});

    for (const key of Object.keys(object)) {
        if (isObject(object[key])) {
            delete object[key];
        }
    }

    return object;
}
